import React from "react";
import ModeChoice from "./ModeChoice";

interface DarkChoiceProps {
  isSelected: boolean;
}

const DarkChoice: React.FC<DarkChoiceProps> = ({ isSelected }) => (
  <ModeChoice
    isSelected={isSelected}
    mode="dark"
    classNames={{
      container:
        "h-full w-full bg-black85 dark-choice p-6 pe-3 text-start flex flex-col rounded-tl-[10px] rounded-bl-[10px]",
      title: "text-white font-bold text-25 uppercase ",
      description:
        "mt-3  text-white text-[13px] md:text-16 md:pb-2 flex-1 flex flex-col gap-2 md:gap-3 ",
    }}
    translationPrefix="darkChoice"
    showDarkWarning={true}
  />
);

export default DarkChoice;
